import { render, staticRenderFns } from "./NetworkError.vue?vue&type=template&id=8e83e998&lang=pug&"
import script from "./NetworkError.vue?vue&type=script&lang=ts&"
export * from "./NetworkError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NetworkError.vue"
export default component.exports